import { action } from 'satcheljs/lib/legacy';
import { ComposeViewState } from 'owa-mail-compose-store';

export default action('setIsDirty')(function setIsDirty(viewState: ComposeViewState) {
    viewState.isDirty = true;
});
